import {
  CalendarDaysIcon,
  FileTextIcon,
  HomeIcon,
  ImagesIcon,
  MessageSquareTextIcon,
  ReceiptTextIcon,
  SettingsIcon,
  UsersIcon,
  WrenchIcon,
  type LucideIcon,
} from 'lucide-react'

export interface AdminNavItem {
  label: string
  to: string
  icon: LucideIcon
  end?: boolean
  /** Viser antal nye henvendelser som badge. */
  showEnquiryBadge?: boolean
}

export interface AdminNavSection {
  title: string
  items: AdminNavItem[]
}

export const adminNav: AdminNavSection[] = [
  {
    title: 'Oversigt',
    items: [{ label: 'Overblik', to: '/admin', icon: HomeIcon, end: true }],
  },
  {
    title: 'Kunder',
    items: [
      { label: 'Henvendelser', to: '/admin/henvendelser', icon: MessageSquareTextIcon, showEnquiryBadge: true },
      { label: 'Kunder', to: '/admin/kunder', icon: UsersIcon },
    ],
  },
  {
    title: 'Arbejde',
    items: [
      { label: 'Sager', to: '/admin/sager', icon: WrenchIcon },
      { label: 'Kalender', to: '/admin/kalender', icon: CalendarDaysIcon },
      { label: 'Cases', to: '/admin/cases', icon: ImagesIcon },
    ],
  },
  {
    title: 'Økonomi',
    items: [
      { label: 'Tilbud', to: '/admin/tilbud', icon: FileTextIcon },
      { label: 'Fakturaer', to: '/admin/fakturaer', icon: ReceiptTextIcon },
    ],
  },
  {
    title: 'System',
    items: [{ label: 'Indstillinger', to: '/admin/indstillinger', icon: SettingsIcon }],
  },
]

/** Hurtig adgang i bundmenuen på mobil. */
export const mobileQuickNav: AdminNavItem[] = [
  { label: 'Overblik', to: '/admin', icon: HomeIcon, end: true },
  { label: 'Henvendelser', to: '/admin/henvendelser', icon: MessageSquareTextIcon, showEnquiryBadge: true },
  { label: 'Sager', to: '/admin/sager', icon: WrenchIcon },
  { label: 'Kalender', to: '/admin/kalender', icon: CalendarDaysIcon },
]

/** Stemningsbillede øverst på Overblik. */
export const adminHeroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/7207cef3-44f2-4229-b851-4c198d544c24.jpg'
